import React, { useRef, useState } from 'react';
import axios from 'axios';
import { addDataServeice } from './uploadApi';
import { Box, Button, Typography } from '@mui/material';
import IosShareIcon from '@mui/icons-material/IosShare';
import uploadIcon from '../../assets/uploadIcon.png';
const FileUpload = ({ api, text }) => {
  const [file, setFile] = useState(null);

  // Handle file selection
  const handleFileChange = async (event) => {
    event.preventDefault()
    const formData = new FormData();
    formData.append('file', event.target.files[0]);
    addDataServeice(api, formData, (data) => {
      console.log("data added", data)
    })

    setFile(event.target.files[0]); // Store the selected file
  };

  // Handle form submit and send API request
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!file) {
      alert('Please select a file first.');
      return;
    }

  };
  const ref1 = useRef()
  const handleIconClick = (event) => {
    event.preventDefault(); // Prevent button default behavior (reload)
    ref1.current?.click(); // Trigger hidden file input click
  };
  return (
    <div>
      <form>
        <input
          ref={ref1}
          type="file"
          id="imageUpload"
          style={{ display: "none" }}
          accept=".xlsx, .xls"
          onChange={handleFileChange}
        />
        {/* <Button
          variant="contained"
          fullWidth
          sx={{height: "50px"}}
          onClick={handleIconClick}
          startIcon={<IosShareIcon />}
        >
          {text}
        </Button> */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "45px",
            color: "#fff",
            backgroundColor: "#01008B",
            borderRadius: "5px",
            cursor: "pointer",
          }}
          onClick={handleIconClick}
        >
          <Typography
            sx={{
              width: "15%",
              textAlign: "right",
              marginTop: "5px",
              paddingRight: "50px",
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
            }}
          >
            <img src={uploadIcon} style={{ height: "25px" }} alt="icon" />
          </Typography>
          <Typography
            sx={{
              flexGrow: 1,
              fontSize: "16px",
              fontWeight: 600,
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
            }}
          >
            {text}
          </Typography>
        </Box>
      </form>
    </div>
  );
};

export default FileUpload;
